'use strict';

const _ = require('underscore');
const ProjectStatusRepository = require('common/domain/repository/project-status');
const ProjectStatusCollection = require('common/domain/collection/project-status');

class ProjectStatusCollectionFactory {
    constructor(group) {
        this._group = group;
        this._repository = ProjectStatusRepository.find(this._group);

        this._collections = {};
    }

    _build(key, options = {}) {
        let c = this._collections[key];
        if (!c) {
            const models = [];
            c = new ProjectStatusCollection(models, _.extend(options, {
                group: this._group,
                repository: this._repository
            }));
            this._collections[key] = c;
        }
        return c;
    }

    getActiveProjectStatusCollection() {
        return this._build(
            'active',
            {
                condition: {
                    inProgress: true
                },
                filter: (projectStatus) => {
                    const stateType = projectStatus.getStateType();
                    return _.contains(['initial', 'normal'], stateType);
                },
                comparator: (projectStatus) => {
                    const stateType = projectStatus.getStateType();
                    const stateOrder = ['normal', 'initial'].indexOf(stateType);
                    const projectName = projectStatus.getName().toLowerCase();

                    return `${stateOrder}-${projectName}`
                }
            }
        );
    }

    getInactiveProjectStatusCollection() {
        return this._build(
            'inactive',
            {
                condition: {
                    inProgress: false
                },
                filter: (projectStatus) => {
                    const stateType = projectStatus.getStateType();
                    return _.contains(['final', 'terminated'], stateType);
                },
                comparator: (projectStatus) => {
                    const stateType = projectStatus.getStateType();
                    const stateOrder = ['final', 'terminated'].indexOf(stateType);
                    const projectName = projectStatus.getName().toLowerCase();

                    return `${stateOrder}-${projectName}`
                }
            }
        );
    }
}

const factories = {};

const find = (group) => {
    let r = factories[group.id];
    if (!r) {
        r = new ProjectStatusCollectionFactory(group);
        factories[group.id] = r;
    }
    return r;
};

module.exports = {
    find: find
};



// WEBPACK FOOTER //
// ./common/domain/factory/project-status/collection.js